import React from 'react';
import { Phone, FileText } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPage = () => {
  const { t, language } = useLanguage();
  
  const contentGr = (
    <>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">1. Εισαγωγή</h2>
        <p className="text-slate-600 mb-4">Η παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων περιγράφει τον τρόπο με τον οποίο το WBL – Women's Basketball League (εφεξής «Διοργάνωση») συλλέγει, χρησιμοποιεί, αποθηκεύει και προστατεύει τα προσωπικά δεδομένα των συμμετεχόντων, επισκεπτών του ιστότοπου και συνεργατών του.</p>
        <p className="text-slate-600">Η Διοργάνωση συμμορφώνεται με τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 (GDPR) και την ισχύουσα ελληνική νομοθεσία περί προστασίας δεδομένων.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">2. Υπεύθυνος Επεξεργασίας</h2>
        <p className="text-slate-600 mb-2">Υπεύθυνος Επεξεργασίας είναι το:</p>
        <p className="text-slate-600 font-semibold">WBL – Women's Basketball League</p>
        <p className="text-slate-600">Email επικοινωνίας: info@wbl.gr</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">3. Ποια Δεδομένα Συλλέγουμε</h2>
        <p className="text-slate-600 mb-4">Η Διοργάνωση ενδέχεται να συλλέγει:</p>
        <div className="space-y-4 ml-4">
          <div>
            <p className="font-semibold text-[#1E3A5F]">Α. Στοιχεία Ταυτότητας</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Ονοματεπώνυμο</li>
              <li>Ημερομηνία γέννησης</li>
              <li>Φωτογραφία (εφόσον δοθεί)</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">Β. Στοιχεία Επικοινωνίας</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Email</li>
              <li>Τηλέφωνο</li>
              <li>Στοιχεία υπευθύνου ομάδας</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">Γ. Αθλητικά Στοιχεία</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Ομάδα</li>
              <li>Θέση</li>
              <li>Στατιστικά αγώνων</li>
              <li>Αγωνιστική συμμετοχή</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">Δ. Οπτικοακουστικό Υλικό</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Φωτογραφίες αγώνων</li>
              <li>Βίντεο</li>
              <li>Περιεχόμενο social media</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">4. Σκοπός Επεξεργασίας</h2>
        <p className="text-slate-600 mb-2">Τα προσωπικά δεδομένα συλλέγονται για:</p>
        <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mb-4">
          <li>Την εγγραφή και συμμετοχή στη διοργάνωση</li>
          <li>Τη διαμόρφωση αγωνιστικών ρόστερ</li>
          <li>Τη δημοσίευση αποτελεσμάτων & στατιστικών</li>
          <li>Την επικοινωνία με ομάδες και αθλήτριες</li>
          <li>Την προβολή της διοργάνωσης (ιστοσελίδα & social media)</li>
          <li>Τη συμμόρφωση με νομικές υποχρεώσεις</li>
        </ul>
        <p className="text-slate-600 mb-2">Η επεξεργασία βασίζεται:</p>
        <ul className="list-disc list-inside text-slate-600 ml-4">
          <li>στη συγκατάθεση του υποκειμένου</li>
          <li>στην εκτέλεση σύμβασης συμμετοχής</li>
          <li>σε έννομο συμφέρον της διοργάνωσης</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">5. Υποχρεωτικά & Προαιρετικά Δεδομένα</h2>
        <p className="text-slate-600 mb-2">Τα υποχρεωτικά στοιχεία επισημαίνονται στις φόρμες εγγραφής.</p>
        <p className="text-slate-600 mb-2">Η μη παροχή υποχρεωτικών στοιχείων ενδέχεται να καθιστά αδύνατη τη συμμετοχή στη διοργάνωση.</p>
        <p className="text-slate-600">Η παροχή προαιρετικών στοιχείων δεν επηρεάζει τη συμμετοχή.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">6. Κοινοποίηση Δεδομένων</h2>
        <p className="text-slate-600 mb-4">Η Διοργάνωση δεν πωλεί ούτε εμπορεύεται προσωπικά δεδομένα.</p>
        <p className="text-slate-600 mb-2">Τα δεδομένα ενδέχεται να κοινοποιηθούν:</p>
        <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mb-4">
          <li>σε διαιτητές & υπευθύνους αγώνων (μόνο εφόσον απαιτείται)</li>
          <li>σε συνεργαζόμενους παρόχους τεχνικών υπηρεσιών (π.χ. hosting, φόρμες)</li>
          <li>σε δημόσιες αρχές, εφόσον απαιτείται από τον νόμο</li>
        </ul>
        <p className="text-slate-600">Οι συνεργάτες δεσμεύονται συμβατικά για εμπιστευτικότητα και ασφάλεια δεδομένων.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">7. Διάρκεια Διατήρησης</h2>
        <p className="text-slate-600 mb-2">Τα προσωπικά δεδομένα διατηρούνται:</p>
        <ul className="list-disc list-inside text-slate-600 ml-4">
          <li>για όσο διάστημα διαρκεί η συμμετοχή στη διοργάνωση</li>
          <li>για εύλογο χρονικό διάστημα μετά τη λήξη της σεζόν</li>
          <li>ή σύμφωνα με νομικές υποχρεώσεις</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">8. Μέτρα Ασφαλείας</h2>
        <p className="text-slate-600 mb-2">Η Διοργάνωση λαμβάνει κατάλληλα τεχνικά και οργανωτικά μέτρα για:</p>
        <ul className="list-disc list-inside text-slate-600 ml-4">
          <li>την αποτροπή μη εξουσιοδοτημένης πρόσβασης</li>
          <li>την προστασία από απώλεια ή αλλοίωση δεδομένων</li>
          <li>την ασφαλή αποθήκευση σε ψηφιακά περιβάλλοντα</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">9. Δικαιώματα Υποκειμένων</h2>
        <p className="text-slate-600 mb-2">Κάθε φυσικό πρόσωπο έχει δικαίωμα:</p>
        <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mb-4">
          <li>Πρόσβασης στα δεδομένα του</li>
          <li>Διόρθωσης ανακριβών στοιχείων</li>
          <li>Διαγραφής («δικαίωμα στη λήθη»)</li>
          <li>Περιορισμού επεξεργασίας</li>
          <li>Φορητότητας δεδομένων</li>
          <li>Ανάκλησης συγκατάθεσης</li>
          <li>Υποβολής καταγγελίας στην Αρχή Προστασίας Δεδομένων</li>
        </ul>
        <p className="text-slate-600">Για την άσκηση των δικαιωμάτων: <strong>info@wbl.gr</strong></p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">10. Χρήση Φωτογραφιών & Βίντεο</h2>
        <p className="text-slate-600 mb-2">Η συμμετοχή στη διοργάνωση συνεπάγεται πιθανή λήψη και δημοσίευση φωτογραφιών ή βίντεο για σκοπούς προβολής της διοργάνωσης.</p>
        <p className="text-slate-600">Σε περίπτωση διαφωνίας, το υποκείμενο δύναται να ζητήσει περιορισμό ή αφαίρεση συγκεκριμένου υλικού.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">11. Cookies & Τεχνολογίες Ιστότοπου</h2>
        <p className="text-slate-600 mb-2">Ο ιστότοπος ενδέχεται να χρησιμοποιεί βασικά τεχνικά cookies για τη λειτουργία του.</p>
        <p className="text-slate-600">Δεν χρησιμοποιούνται cookies παρακολούθησης για εμπορική εκμετάλλευση.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">12. Εφαρμοστέο Δίκαιο</h2>
        <p className="text-slate-600">Η επεξεργασία δεδομένων διέπεται από το Ελληνικό Δίκαιο και τον GDPR.</p>
      </section>
      <section>
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">13. Τροποποιήσεις Πολιτικής</h2>
        <p className="text-slate-600">Η Διοργάνωση διατηρεί το δικαίωμα τροποποίησης της παρούσας Πολιτικής. Η πιο πρόσφατη έκδοση είναι πάντοτε διαθέσιμη στον ιστότοπο.</p>
      </section>
    </>
  );
  
  const contentEn = (
    <>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">1. Introduction</h2>
        <p className="text-slate-600 mb-4">This Privacy Policy describes how the WBL – Women's Basketball League ("Organization") collects, uses, stores and protects personal data of participants, website visitors and partners.</p>
        <p className="text-slate-600">The Organization complies with the General Data Protection Regulation (EU) 2016/679 (GDPR) and applicable Greek data protection legislation.</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">2. Data Controller</h2>
        <p className="text-slate-600 mb-2">Data Controller is:</p>
        <p className="text-slate-600 font-semibold">WBL – Women's Basketball League</p>
        <p className="text-slate-600">Contact email: info@wbl.gr</p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">3. Data We Collect</h2>
        <p className="text-slate-600 mb-4">The Organization may collect:</p>
        <div className="space-y-4 ml-4">
          <div>
            <p className="font-semibold text-[#1E3A5F]">A. Identity Data</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Full name</li>
              <li>Date of birth</li>
              <li>Photograph (if provided)</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">B. Contact Data</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Email</li>
              <li>Phone</li>
              <li>Team manager details</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">C. Athletic Data</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Team</li>
              <li>Position</li>
              <li>Game statistics</li>
              <li>Game participation</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-[#1E3A5F]">D. Audiovisual Material</p>
            <ul className="list-disc list-inside text-slate-600 ml-4">
              <li>Game photographs</li>
              <li>Videos</li>
              <li>Social media content</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">4. Purpose of Processing</h2>
        <p className="text-slate-600 mb-2">Personal data is collected for:</p>
        <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mb-4">
          <li>Registration and participation in the league</li>
          <li>Team roster management</li>
          <li>Publication of results & statistics</li>
          <li>Communication with teams and athletes</li>
          <li>League promotion (website & social media)</li>
          <li>Legal compliance</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">5. Data Subject Rights</h2>
        <p className="text-slate-600 mb-2">Every individual has the right to:</p>
        <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mb-4">
          <li>Access their data</li>
          <li>Rectification of inaccurate data</li>
          <li>Erasure ("right to be forgotten")</li>
          <li>Restriction of processing</li>
          <li>Data portability</li>
          <li>Withdrawal of consent</li>
          <li>Lodge a complaint with the Data Protection Authority</li>
        </ul>
        <p className="text-slate-600">To exercise your rights: <strong>info@wbl.gr</strong></p>
      </section>
      <section>
        <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">6. Applicable Law</h2>
        <p className="text-slate-600">Data processing is governed by Greek Law and GDPR.</p>
      </section>
    </>
  );
  
  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="privacy-page">
      <div className="text-center mb-12">
        <div className="w-16 h-16 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center mx-auto mb-4">
          <FileText className="text-[#1E3A5F]" size={32} />
        </div>
        <h1 className="section-title mb-4">{t('privacyTitle')}</h1>
        <p className="text-slate-600">{t('privacySubtitle')}</p>
      </div>
      <div className="card p-8">{language === 'gr' ? contentGr : contentEn}</div>
      <p className="text-center text-slate-400 text-sm mt-8">{language === 'gr' ? 'Τελευταία ενημέρωση: Φεβρουάριος 2026' : 'Last updated: February 2026'}</p>
    </div>
  );
};

export default PrivacyPage;
